import { render } from "./Follow.vue?vue&type=template&id=e026c872&scoped=true"
import script from "./Follow.vue?vue&type=script&lang=js"
export * from "./Follow.vue?vue&type=script&lang=js"

import "./Follow.vue?vue&type=style&index=0&id=e026c872&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e026c872"]])

export default __exports__